import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalState extends BaseModelAPI {
	static entity = 'approvalstate';
	static entityName = 'approvalstate';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}